import React, { useState, useEffect, useRef } from "react";

const Faq = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Orders");
  const [openFaqs, setOpenFaqs] = useState({});
  const [visibleTabs, setVisibleTabs] = useState([]);
  const tabRefs = useRef({});
 
  const allTabs = [
    "Orders",
    "Payments",
    "Products/Stock",
    "Deliveries",
    "Refund/Return",
    "Technical",
  ];
 
  const tabMapping = {
    Orders: "Orders",
    Payments: "Payment Information",
    "Products/Stock": "Products",
    Deliveries: "Delivery Detail",
    "Refund/Return": "Refund",
    Technical: "Technical",
  };
 
  useEffect(() => {
    setLoading(true);
    fetch("https://app.nmp.com.pk/api/faq/", {
      method: "GET",
      headers: {
        Authorization: "Token 774c53eb36f83b8d0f31d167d6709c0c2d28cc65",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setFaqs(data);
        const activeCategories = new Set(
          data.filter((faq) => faq.is_active).map((faq) => faq.category)
        );
        const newVisibleTabs = allTabs.filter((tab) =>
          activeCategories.has(tabMapping[tab])
        );
        setVisibleTabs(newVisibleTabs);
        if (newVisibleTabs.length > 0) {
          setActiveTab(newVisibleTabs[0]);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);
 
  const [lineStyle, setLineStyle] = useState({});
  useEffect(() => {
    if (tabRefs.current[activeTab]) {
      const activeTabElement = tabRefs.current[activeTab];
      setLineStyle({
        width: activeTabElement.offsetWidth,
        left: activeTabElement.offsetLeft,
      });
    }
  }, [activeTab, visibleTabs]);

  const filteredFaqs = faqs.filter(
    (faq) => faq.category === tabMapping[activeTab] && faq.is_active
  );

  const toggleFaq = (id) => {
    setOpenFaqs((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const getIcon = (tab) => {
    switch (tab) {
      case "Orders": return "📦";
      case "Payments": return "💳";
      case "Products/Stock": return "💊";
      case "Deliveries": return "🚚";
      case "Refund/Return": return "🔄";
      case "Technical": return "⚙️";
      default: return "";
    }
  };

  const commonStyles = {
    container: {
      padding: "30px",
      maxWidth: "900px",
      margin: "0 auto",
      fontFamily: "Poppins, sans-serif",
      backgroundColor: "#ffffff",
    },
    heading: {
      textAlign: "left",
      marginBottom: "30px",
      fontSize: "24px",
      fontWeight: "800",
      color: "#2c3e50",
      textTransform: "uppercase",
      letterSpacing: "1px",
    },
    tabsWrapper: {
      display: "flex",
      overflowX: "auto",
      whiteSpace: "nowrap",
      borderBottom: "2px solid #e0e0e0",
      marginBottom: "20px",
      WebkitOverflowScrolling: "touch",
      position: "relative",
      justifyContent: "flex-start",
      // 👇 New Code to hide scrollbar and buttons 👇
      msOverflowStyle: "none", // For Internet Explorer and Edge
      scrollbarWidth: "none", // For Firefox
      "&::-webkit-scrollbar": { // For Chrome, Safari, and other WebKit browsers
        display: "none",
      },
      // 👆 End of new code 👆
    },
    tabButton: {
      flexShrink: 0,
      border: "none",
      backgroundColor: "transparent",
      padding: "15px 25px",
      fontSize: "0.9rem",
      fontWeight: "600",
      cursor: "pointer",
      outline: "none",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#7f8c8d",
      transition: "all 0.3s ease",
      position: "relative",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    tabActive: {
      color: "#e74c3c",
      fontWeight: "bold",
    },
    tabLine: {
      position: "absolute",
      bottom: "-2px",
      height: "4px",
      backgroundColor: "#e74c3c",
      transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      borderRadius: "2px",
    },
    faqContent: {
      padding: "20px 0",
    },
    faqItem: {
      marginBottom: "15px",
      border: "1px solid #ddd", 
      borderRadius: "10px",
      overflow: "hidden",
      boxShadow: "0 4px 12px rgba(248, 243, 243, 0.08)",
      transition: "box-shadow 0.3s ease, border-color 0.3s ease",
      outline: "none",
      outline: "none",
    },
    faqItemOpen: {
      borderColor: "#ddd",
      boxShadow: "0 4px 12px rgba(248, 243, 243, 0.08)",
      outline: "none",
    },
    faqQuestion: {
      padding: "18px 25px",
      fontWeight: "600",
      fontSize: "1rem",
      color: "#34495e",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#f9f9f9", 
      transition: "background-color 0.3s ease",
      textAlign: "left",
      outline: "none",
      border: "none",
    },
    faqQuestionHover: {
      backgroundColor: "#f0f0f0",
    },
    faqAnswer: {
      maxHeight: "0",
      overflow: "hidden",
      padding: "0 25px",
      transition: "max-height 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94), padding 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      fontSize: "0.95rem",
      lineHeight: "1.6",
      color: "#555",
      backgroundColor: "#ffffff",
    },
    faqAnswerOpen: {
      padding: "20px 25px",
    },
    faqArrow: {
      fontSize: "1.2rem",
      transition: "transform 0.4s ease, color 0.4s ease",
      color: "#95a5a6",
    },
    faqArrowOpen: {
      transform: "rotate(90deg)",
      color: "#95a5a6", 
    },
    loadingText: {
      textAlign: "center",
      fontSize: "1.2rem",
      color: "#95a5a6",
    },
    noFaqsText: {
      textAlign: "center",
      fontSize: "1.2rem",
      color: "#95a5a6",
    },
  };

  return (
    <div style={commonStyles.container}>
      <h1 style={commonStyles.heading}>
        Frequently Asked Questions
      </h1>
      <div style={commonStyles.tabsWrapper}>
        {visibleTabs.map((tab) => (
          <button
            key={tab}
            ref={(el) => (tabRefs.current[tab] = el)}
            onClick={() => setActiveTab(tab)}
            style={{
              ...commonStyles.tabButton,
              ...(activeTab === tab ? commonStyles.tabActive : {}),
            }}
          >
            {getIcon(tab)} {tab.toUpperCase()}
          </button>
        ))}
        <div style={{ ...commonStyles.tabLine, ...lineStyle }}></div>
      </div>
      <div style={commonStyles.faqContent}>
        {loading ? (
          <p style={commonStyles.loadingText}>Loading...</p>
        ) : filteredFaqs.length === 0 ? (
          <p style={commonStyles.noFaqsText}>No FAQs available for this category.</p>
        ) : (
          <div>
            {filteredFaqs.map((faq, index) => (
              <div
                key={faq.id}
                style={{
                  ...commonStyles.faqItem,
                  ...(openFaqs[faq.id] ? commonStyles.faqItemOpen : {}),
                }}
              >
                <div
                  onClick={() => toggleFaq(faq.id)}
                  style={commonStyles.faqQuestion}
                  tabIndex={-1}
                >
                  <span style={{textAlign: 'left'}}>
                    Q{index + 1}: {faq.question}
                  </span>
                  <span
                    style={{
                      ...commonStyles.faqArrow,
                      ...(openFaqs[faq.id] ? commonStyles.faqArrowOpen : {}),
                    }}
                  >
                    ▶
                  </span>
                </div>
                <div
                  style={{
                    ...commonStyles.faqAnswer,
                    ...(openFaqs[faq.id] ? commonStyles.faqAnswerOpen : {}),
                    maxHeight: openFaqs[faq.id] ? "500px" : "0",
                  }}
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Faq;